
/** 模块状态 */
export default class AppContainerState {

    /** 加载成功的app */
    public App: any;
}


// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/display/components/AppContainer/AppContainerState.ts